import SpecialEventConfiguration from "./-modules";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/specialEventConfiguration/")({
  staticData: {
    menuLabel: "专场配置",
    showInMenu: true,
    menuGroup: "/opr",
    menuOrder: 2,
  },
  component: SpecialEventConfiguration,
});
